import React from "react";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import styles from "./Footer.module.scss";
import SocialMediaIcon from "../Button/SocialMediaIcon";
import { LEGAL_CONFIG } from "../../config/legal";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.board}>
        <div className={styles.brandBlock}>
          <h3 className={styles.brand}>{LEGAL_CONFIG.platformName}</h3>
          <p className={styles.brandSubtitle}>
            <FormattedMessage
              id="footer.brand.subtitle"
              defaultMessage="Digital sewing patterns marketplace"
            />
          </p>
          {LEGAL_CONFIG.showFooterSocialIcons && (
            <div className={styles.socials}>
              <SocialMediaIcon icon={"facebook f"} className={styles.socialMedia} />
              <SocialMediaIcon icon={"instagram"} className={styles.socialMedia} />
            </div>
          )}
        </div>

        <div className={styles.linksBlock}>
          <h4 className={styles.blockTitle}>
            <FormattedMessage id="footer.links.title" defaultMessage="Links" />
          </h4>
          <div className={styles.linksColumns}>
            <div className={styles.linkColumn}>
              <Link to="/platform-terms?page=privacy-policy" className={styles.footerLink}>
                <FormattedMessage
                  id="footer.links.privacyPolicy"
                  defaultMessage="Privacy Policy"
                />
              </Link>
              <Link to="/platform-terms?page=terms-of-service" className={styles.footerLink}>
                <FormattedMessage
                  id="footer.links.platformTerms"
                  defaultMessage="Platform Terms"
                />
              </Link>
              <Link to="/platform-terms?page=designers" className={styles.footerLink}>
                <FormattedMessage
                  id="footer.links.creatorTerms"
                  defaultMessage="Creator Terms"
                />
              </Link>
            </div>
            <div className={styles.linkColumn}>
              <Link to="/platform-terms?page=newsLetter" className={styles.footerLink}>
                <FormattedMessage
                  id="footer.links.newsletterTerms"
                  defaultMessage="Newsletter Terms"
                />
              </Link>
              <Link to="/contact" className={styles.footerLink}>
                <FormattedMessage id="nav.contact" defaultMessage="Contact" />
              </Link>
            </div>
          </div>
        </div>

        <div className={styles.contactBlock}>
          <h4 className={styles.blockTitle}>
            <FormattedMessage id="footer.support.title" defaultMessage="Support" />
          </h4>
          <a
            href={`mailto:${LEGAL_CONFIG.supportEmail}`}
            className={styles.footerLink}
          >
            {LEGAL_CONFIG.supportEmail}
          </a>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
